import { memo } from "react"
import HexagonSwirl from '../assets/animations/hexagonSwirl.json';
import Lottie from "lottie-react";

const AIAgentBorder: React.FC = () => {
  return (
    <Lottie
        animationData={HexagonSwirl}
        loop={true}
        style={{
          width: '50px',
          height: '50px',
          position: 'absolute',
          top: '-1px',
        }}
      />
  )
}

export default memo(AIAgentBorder)
